import { render, staticRenderFns } from "./SharedCPDAdminRejectModal.vue?vue&type=template&id=8f22dc72&scoped=true&"
import script from "./SharedCPDAdminRejectModal.vue?vue&type=script&lang=js&"
export * from "./SharedCPDAdminRejectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f22dc72",
  null
  
)

export default component.exports